
import $prompts from 'stores/prompts'
export default {
  props: {
    copying: {
      type: Boolean,
      default: false
    },
    promptId: {
      type: String,
      default: undefined
    },
    owner: {
      type: Object,
      required: true
    }
  },
  emits: ['cancel', 'duplicate'],
  computed: {
    name(){
      if (this.owner.first_name && this.owner.last_name) {
        return `${this.owner.first_name} ${this.owner.last_name}`
      }
      return this.owner.name
    },
    email(){
      return this.owner.email
    },
    avatar_url(){
      return this.owner.avatar_url
    },
    self_prompt(){
      return $prompts.prompts.some(item => item.id === this.promptId)
    }
  },
}
